import { render, staticRenderFns } from "./RestaurantAddress.vue?vue&type=template&id=80b749f2&"
import script from "./RestaurantAddress.vue?vue&type=script&lang=js&"
export * from "./RestaurantAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports